import { Company } from 'models'
import { ALL_ACCOUNTS_ID } from '../constants'

const isAllAccountsOption = (company: Company | null | undefined) => company?.id === ALL_ACCOUNTS_ID

const areSelectionsEqual = (a: Array<Company>, b: Array<Company>) =>
  a.length === b.length && a.every((company, index) => company.id === b[index]?.id)

const reconcileSelection = (
  selection: Array<Company>,
  available: Array<Company>,
  limit: number,
) => {
  if (!selection.length || limit <= 0) return []

  const availableById = available.reduce<Record<string, Company>>((acc, company) => {
    if (company.id) {
      acc[company.id] = company
    }
    return acc
  }, {})

  const seen = new Set<string>()
  return selection.reduce<Array<Company>>((acc, company) => {
    if (acc.length >= limit) {
      return acc
    }

    const id = company?.id
    if (!id || seen.has(id)) {
      return acc
    }

    const availableCompany = availableById[id]
    if (!availableCompany) {
      return acc
    }

    acc.push(availableCompany)
    seen.add(id)
    return acc
  }, [])
}

type SelectionState = {
  mode: 'none' | 'single' | 'multiple' | 'allAccounts'
  items: Array<Company>
}

const buildSelectionState = (options: {
  selection: Array<Company>
  isAllAccounts: boolean
}): SelectionState => {
  if (options.isAllAccounts && options.selection.length) {
    return { mode: 'allAccounts', items: options.selection }
  }

  if (options.selection.length === 1) {
    return { mode: 'single', items: options.selection }
  }

  if (options.selection.length > 1) {
    return { mode: 'multiple', items: options.selection }
  }

  return { mode: 'none', items: [] }
}

export type { SelectionState }
export { isAllAccountsOption, areSelectionsEqual, reconcileSelection, buildSelectionState }
